module.exports = __webpack_public_path__ + "static/media/import.e1fc3c54.svg";